import { render, staticRenderFns } from "./micro-awareness.vue?vue&type=template&id=048d3574&scoped=true"
import script from "./micro-awareness.vue?vue&type=script&lang=js"
export * from "./micro-awareness.vue?vue&type=script&lang=js"
import style0 from "./micro-awareness.vue?vue&type=style&index=0&id=048d3574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d3574",
  null
  
)

export default component.exports